import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_ATTACHMENTS_FILE_MANAGER_HANDLER = {
  topic: TOPIC_NAMES.OPEN_ATTACHMENTS_FILE_MANAGER,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/AttachmentsFileManager')
};